import React from 'react'
import { SearchWithOtherQuery, QueryItem } from './styled'

type Props = {
  title: string,
  category_abbreviation: string,
  queryItems: QueryItem[],
}

const Index: React.FC<Props> = (props) => {
  return (
    <SearchWithOtherQuery title={props.title} category_abbreviation={props.category_abbreviation} queryItems={props.queryItems}/>
  )
}

export default Index
